<template>
	<div class="m-scroll-image">
		<div class="m-scroll-image-head flex-between-center">
			<p>{{unitData.title_text}}</p>
			<span v-if="unitData.more_link" class="more">{{unitData.more_text || '查看更多'}}</span>
		</div>
		<div class="m-scroll-image-list flex">
			<ul class="flex">
				<li v-for="(item, i) in unitData.list" :key="i">
					<c-image class="image" :src="item.img_url"></c-image>
					<p v-if="unitData.show_list_title == 1">{{item.title}}</p>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				unitData: {}
			}
		},
		
		mounted() {
		},
		
		methods: {
		}
	}
</script>

<style lang="stylus" scoped>
	.m-scroll-image {
		border-radius: 10px;
		margin: 10px;
		overflow: hidden;
		background: #fff;
		
		&-head {
			height: 48px;
			padding: 0 12px;
			
			p {
				font-size: 18px;
				font-weight: bold
			}
			
			.more {
				font-size: 12px;
				color: #999;
			}
		}
		
		&-list {
			margin: 0 12px;
			overflow: hidden;
			
			ul {
				float: left;
				
				li {
					width: 230px;
					
					&:nth-child(n+2) {
						margin-left: 12px;
					}
					
					.image {
						height: 140px;
					}
					
					p {
						line-height: 35px;
						font-size: 13px;
						text-align: center;
						color: #333;
					}
				}
			}
		}
	}
</style>
